import { Validators } from '@angular/forms';
import { ErrorMessages, Rule } from '@ubud/form';

/**
 *  @author     Arif Setianto <arifsetiantoo@gmail.com>
 *  @created    16/06/2018
 */
export class RegisterInstitutionPrivateRule extends Rule {
    public get errorMessages(): ErrorMessages {
        return {
            license_number: {
                required: (params: any) => 'No. lisensi tidak boleh kosong',
            },
            license_file: {
                required: (params: any) => 'File lisensi tidak boleh kosong',
            },
            tax_number: {
                required: (params: any) => 'No. NPWP tidak boleh kosong',
            },
            tax_file: {
                required: (params: any) => 'File NPWP tidak boleh kosong',
            },
            pic_identity_number: {
                required: (params: any) => 'No. identitas PIC tidak boleh kosong',
            },
        };
    }

    public get licenseNumber(): Function {
        return Validators.required;
    }

    public get licenseFile(): Function {
        return Validators.required;
    }

    public get taxNumber(): Function {
        return Validators.required;
    }

    public get taxFile(): Function {
        return Validators.required;
    }

    public picIdentityNumber(): Function {
        return Validators.required;
    }

    public getFormControls(): { [p: string]: any } {
        return {
            license_number: ['', this.licenseNumber],
            license_file: ['', this.licenseFile],
            tax_number: ['', this.taxNumber],
            tax_file: ['', this.taxFile],
            pic_identity_number: ['', this.picIdentityNumber()],
        };
    }
}



// WEBPACK FOOTER //
// ./src/lemsar/auth/rules/register-institution-private.rule.ts